<template>
    <div>
        <!-- delete dialog -->
        <delete-dialog
            ref="deleteDialog"
            :success-message="$t('message.data-is-deleted')"
            @on-delete="fetchAll"
        >
            <v-icon size="22" color="alert-color"> mdi-alert-outline </v-icon>
			{{ $t('EmployeeStock.the-employee-is-balance-is-being-prepared-for-the-day') }}
        </delete-dialog>
        <!-- dialog posted -->
        <v-dialog v-model="dialogPosted" width="450" @keydown.esc="dialogPosted = false">
            <v-card>
                <div 
                    class="d-flex justify-end py-1 background-title-card py-1 "
                >
                    <v-card-title
                        class="text-uppercase text-subtitle-1 flex-grow-1 justify-center pa-0 white--text"
                    >
                        {{$t('Staff.toggle-employee-account-status')}}
                    </v-card-title>
                    <!-- close button -->
                    <v-btn icon @click="dialogPosted = false">
                        <v-icon color="white">
                            mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </div>

                <v-card-text class="text-body-1 pb-0 pt-2">
                    {{ $t('EmployeeStock.are-you-sure-you-want-to-migrate-this-journal') }}
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn
                        :loading="submitLoading"
                        color="success white--text"
                        class="white--text"
                        text
                        @click="submitPosted()"
                    >
                        {{$t('confirm')}}
                    </v-btn>
                    <v-btn
                        text
                        :disabled="submitLoading"
                        @click="dialogPosted = false"
                    >
                        {{$t('close')}}
                    </v-btn>
                </v-card-actions>
                </v-card>
        </v-dialog>
        <!-- dialog -->
        <v-dialog v-model="dialog" width="500" @keydown.esc="dialog = false">
            <v-card>
                <div class="d-flex py-1 primary">
                    <v-card-title
                        class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
                    >
                        {{ $t('EmployeeStock.add-a-record') }}
                    </v-card-title>

                    <v-btn icon @click="dialog = false">
                        <v-icon color="white"> mdi-close-circle-outline </v-icon>
                    </v-btn>
                </div>

                <v-card-text class="pt-2 px-3 pb-0">
                    <v-row dense class="ma-0">
                        <v-col cols="6">
                            <v-autocomplete 
                                v-model="dialogData.employeeId"
                                :items="!itemId ? medicalRepsBrief.filter(item1 => !employeeStock.some(item2 => item2.employeeId === item1.id )) : medicalRepsBrief"
                                item-text="name"
                                item-value="id"
                                dense
                                outlined
                                hide-details
                                :label="$t('inputs.employee')"
                                :disabled="submitLoading"
                            />
                        </v-col>

                        <v-col cols="6" class="px-1">
                            <bee-date-picker
                                v-model="dialogData.date"
                                :input-label="$t('inputs.date')"
                                menu-picker
                                dense
                                hide-details
                                :input-props="{
                                    outlined: true,
                                    dense: true,
                                    clearable: true
                                }"
                                :allowed-dates="disableDates"
                                :disabled="submitLoading"
                            ></bee-date-picker>
                        </v-col>

                        <v-col cols="6">
                            <v-text-field 
                                v-model.number="dialogData.amountDelivered"
                                dense
                                outlined
                                hide-details
                                clearable
                                :label="$t('inputs.amount-delivered')"
                                :disabled="submitLoading"
                            />
                        </v-col>

                        <v-col cols="6">
                            <v-text-field 
                                v-model.number="dialogData.amountReceived"
                                dense
                                outlined
                                hide-details
                                clearable
                                :label="$t('inputs.amount-received')"
                                :disabled="submitLoading"
                            />
                        </v-col>

                        <v-col cols="12" align-self="center">
                            <v-radio-group 
                                v-model="dialogData.isPosted" 
                                row 
                                hide-details 
                                class="mt-0" 
                                :disabled="submitLoading"
                            >
                                <v-radio :value="true" :label="$t('inputs.posted')" />
                                <v-radio :value="false" :label="$t('inputs.unPosted')" />
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea 
                                v-model="dialogData.notes"
                                dense
                                outlined
                                hide-details
                                clearable
                                :label="$t('inputs.notes')"
                                rows="2"
                                :disabled="submitLoading"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn
                        text
                        color="success"
                        :loading="submitLoading"
                        @click="submit()"
                    >
                        {{$t('save')}}
                    </v-btn>
                    <v-btn
                        text
                        :disabled="submitLoading"
                        @click="dialog = false"
                    >
                        {{$t('cancel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- filter -->
        <v-row class="my-1 mx-1">
            <!-- filter -->
            <v-col cols="12" sm="12" md="3" class="pa-1">
                <v-autocomplete 
                    v-model="employeeIds"
                    :items="medicalRepsBrief"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    multiple
                    :label="$t('inputs.employees')"
                    clearable
                    :disabled="loading"
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                        <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                        >
                            (+{{ employeeIds.length - 1 }})
                        </span>
                    </template> 
                </v-autocomplete>
            </v-col>
            <v-col cols="auto"  class="pa-1">
                <v-radio-group
                    v-model="dateType"
                    row
                    class="mt-1"
                    hide-details
                    :disabled="loading"
                >
                    <v-radio
                        :label="$t('daily-date')"
                        value="daily"
                    ></v-radio>
                    <v-radio
                        :label="$t('from-date') + ' / ' + $t('to-date')"
                        value="period"
                    ></v-radio>
                </v-radio-group>
            </v-col>
            <!-- date -->
            <v-col v-if="dateType === 'period'" cols="6" sm="3" md="2"  class="pa-1">
                <bee-date-picker
                    v-model="fromDate"
                    :input-label="$t('inputs.start-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :allowed-dates="disableDates"
                    :disabled="loading"
                ></bee-date-picker>
            </v-col>
            <!-- end date -->
            <v-col v-if="dateType === 'period'" cols="6" sm="3" md="2"  class="pa-1">
                <bee-date-picker
                    v-model="toDate"
                    :input-label="$t('inputs.end-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :allowed-dates="disableDates"
                    :disabled="loading"
                ></bee-date-picker>
            </v-col>
            <v-col v-if="dateType === 'daily'" cols="12" sm="6" md="3"  class="pa-1">
                <bee-date-input
                    v-model="date"
                    :append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left' "
                    :prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right' "
                    :label="$t('inputs.date')"
                    input-format-order="DD-MM-YYYY"
                    dense
                    :loading="loading"
                    hide-details
                    @click:append="
                        addDate();
                        fetchAll()
                    "
                    @click:prepend="
                        subDate();
                        fetchAll()
                    "
                    :disabled="loading"
                ></bee-date-input>
            </v-col>
            <!-- posted -->
            <v-col cols="auto" class="pa-1">
                <v-btn-toggle
                    v-model="posted"
                    mandatory
                    dense
                    class="mb-1"
                    color="primary"
                    @change="fetchAll()"
                    :disabled="loading"
                >

                    <v-btn :disabled="loading" value="all">
                       {{$t('inputs.all')}} 
                    </v-btn>

                    <v-btn :disabled="loading" :value="false">
                       {{$t('inputs.unPosted')}} 
                    </v-btn>

                    <v-btn :disabled="loading" :value="true">
                       {{$t('inputs.posted')}} 
                    </v-btn>
                </v-btn-toggle>
            </v-col>   

            <v-col class="pa-1" cols="auto" align-self="center">
                <v-checkbox 
                    v-model="isDifferent"
                    :label="$t('EmployeeStock.non-matching-records')"
                    class="my-0"
                    hide-details
                    :disabled="loading"
                />
            </v-col>
            
            <v-spacer v-if="$vuetify.breakpoint.smAndDown" />
            <v-col cols="auto" align-self="center" class="d-flex pa-1 " >
                <v-btn
                    color="success"
                    class="px-sm-4 mx-2"
                    :loading="loading"
                    :disabled="loading"
                    small
                    @click="fetchAll()"
                >
                    <v-icon> mdi-magnify </v-icon>
                    {{$t('search')}}
                </v-btn>

                <v-btn
                    color="alert-color white--text"
                    class="px-sm-8"
                    :disabled="loading"
                    small
                    @click="reset(); fetchAll()"
                >
                    {{$t('reset')}}
                </v-btn>
                <v-divider vertical class="mx-1" />
                <v-btn 	
                    small
            	    color="light-blue white--text" 
                    @click="dialog = true"
                    class=""
                >
                    {{ $t('add') }}
                </v-btn>
            </v-col> 
        </v-row>

        <bee-handy-table
            :headers="headers"
            :items="employeeStock"
            dense
            zebra
            hide-default-footer
            :items-per-page="-1"
            :loading="loading"
            :height="$vuetify.breakpoint.height - 170"
        >
            <template v-slot:item.isPosted="{ item }">
                <v-chip small :color="item.isPosted === true ? 'primary-light' : 'alert'">
                    {{ item.isPosted === true ? 'Posted' : 'UnPosted' }}
                </v-chip>
            </template>

            <!-- actions -->
            <template v-slot:item.actions="{ item }">
                <div class="d-flex">
                    <v-btn
                        :disabled="item.isPosted"
                        icon
                        @click="itemId = item.id; dialogPosted = true"
                        small
                    >
                        <v-icon> mdi-arrow-expand-up </v-icon>
                    </v-btn>
                    <v-btn
                        :disabled="item.isPosted"
                    	icon
                    	color="edit-color"
                    	@click="itemId= item.id; dialog = true"
                    >
                        <v-icon>
                            mdi-pencil
                        </v-icon> 
                    </v-btn>

                    <v-btn 
                        :disabled="item.isPosted"  
                        icon 
                        color="alert-color" 
                        @click="$refs.deleteDialog.activeDeleteDialog(item.id, 'employeeStock')"
                    >
                        <v-icon>
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
        <!-- footer -->
        <v-footer
            v-if="employeeStock.length"
            height="30"
            fixed
            color='#534c495c'
        >
            <v-spacer/>
            <div v-if="employeeStock.length !== 0" class="d-flex">
                <p class="text-body-2 font-weight-bold mx-4">
                    {{ $t('EmployeeStock.total-amount-received') + ': ' }}
                    {{ employeeStock.length !== 0 ? employeeStock[0].totalAmountReceived : '-' }}
                </p>
                <p class="text-body-2 font-weight-bold mx-4">
                    {{ $t('EmployeeStock.total-amount-delivered') + ': '}}
                    {{ employeeStock.length !== 0 ? employeeStock[0].totalAmountDelivered : '-' }}
                </p>
            </div>
            <v-spacer/>
        </v-footer>
    </div>
</template>

<script>
import { isDisabledFriday, enableVacations } from '@/configs/global.config'
import moment from 'moment'
import { mapState } from 'vuex'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { disableDates } from '@/helpers/functions'
export default {
    data () {
        return {
            dateType: 'daily',
            fromDate: null,
            toDate: null,
            date: moment().format('YYYY-MM-DD'),
            isDisabledFriday,
            employeeIds: [],
            loading: false,
            posted: 'all',
            itemId: null,
            dialog: false,
            // dialog data
            dialogData: {
                employeeId: null,
                date: moment().format('YYYY-MM-DD'),
                amountDelivered: 0,
                amountReceived: 0,
                notes: null,
                isPosted: false
            },
            submitLoading: false,
            isDifferent: false,
            disableDates,
            enableVacations,
            dialogPosted: false
        }
    },

    components: {
        DeleteDialog
    },

    watch: {
        dialog(val) {
            if (val) {
                if (this.itemId) {
                    const item = this.employeeStock.find(c => c.id === this.itemId)
                    this.dialogData.employeeId = item.employeeId
                    this.dialogData.date = moment(item.date).format('YYYY-MM-DD')
                    this.dialogData.amountDelivered = item.amountDelivered
                    this.dialogData.amountReceived = item.amountReceived
                    this.dialogData.isPosted = (item.isPosted)
                    this.dialogData.notes = item.notes
                }
            } else {
                this.dialogData.employeeId = null
                this.dialogData.date = moment().format('YYYY-MM-DD')
                this.dialogData.amountDelivered = null
                this.dialogData.amountReceived = null
                this.dialogData.isPosted = false
                this.dialogData.notes = null
                this.itemId = null
            }
        }
    },

    computed: {
        ...mapState({
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
            employeeStock: state => state.employeeStock.employeeStock,
            vacationsDayDetails: state => state.vacations.vacationsDayDetails
        }),
        
        headers () {
            return [
                {
                    text: this.$t('headers.employee'),
                    name: 'employee',
                    value: 'employeeId',
                    setValueExpr: val => this.medicalRepsBrief.find(c => c.id === val)?.name
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                },
                {
                    text: this.$t('headers.amount-delivered'),
                    name: 'amount-delivered',
                    value: 'amountDelivered'
                },
                {
                    text: this.$t('headers.amount-received'),
                    name: 'amount-received',
                    value: 'amountReceived'
                },
                {
                    text: this.$t('headers.status'),
                    name: 'isPosted',
                    value: 'isPosted'
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'notes',
                    value: 'notes'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        }
    },

    methods: {
        moment,
        fetchAll () {
            this.loading = true
            this.$store.dispatch('employeeStock/fetchEmployeeStock', { 
                fromDate: this.dateType === 'daily' ? this.date : this.fromDate, 
                toDate: this.dateType === 'daily' ? this.date : this.toDate, 
                isPosted: this.posted !== 'all' ? Boolean(this.posted) : null, 
                isDifferent: this.isDifferent, 
                // note, 
                employeeIds: this.employeeIds
            }).finally(() => {
                this.loading = false
            })
        },
        submit () {
            this.submitLoading = true
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`employeeStock/${actionName}`, { 
                employeeId: this.dialogData.employeeId,
                date: this.dialogData.date,
                amountDelivered: this.dialogData.amountDelivered,
                amountReceived: this.dialogData.amountReceived,
                notes: this.dialogData.notes,
                isPosted: this.dialogData.isPosted,
                id: this.itemId
            }).then(() => {
                this.dialog = false
                this.fetchAll()
            }).finally(() => {
                this.submitLoading = false
            })
        },
        addDate () {
            this.date = moment(this.date).add(1, 'day').format('YYYY-MM-DD');
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) ||
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.addDate()
            }
            return this.date
        },

        subDate() {
            this.date = moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) || 
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.subDate()
            }
            return this.date
        },

        reset() {
            this.dialogData.date = moment().format('YYYY-MM-DD')
            this.employeeIds = []
            this.dateType = 'daily'
            this.itemId = null
            this.fromDate = moment(moment().startOf('month')).format('YYYY-MM-DD')
            this.toDate = moment(moment().endOf('month')).format('YYYY-MM-DD')
            this.date = moment().format('YYYY-MM-DD')
            this.posted = 'all'
            this.isDifferent = false
        },

        submitPosted () {
            this.submitLoading = true
            this.$store.dispatch('employeeStock/posted', { id: this.itemId }).then(() => {
                this.dialogPosted = false
                this.fetchAll()
            }).finally(() => {
                this.submitLoading = false
            })
        }
        
    },

    created () {
        if (!this.medicalRepsBrief.length) {
            this.$store.dispatch('medicalreps/fetchAllBrief', true)
        }
        if (enableVacations && !this.vacationsDayDetails.length) this.$store.dispatch('vacations/fetchAll')
        this.fetchAll()
    }
}
</script>